export const logError = (...error: unknown[]) => {
  // eslint-disable-next-line no-console
  console.log(...error);
};
